import React from 'react';
import Box from "@mui/material/Box";
import Authenticated from "../components/Authenticated";
import Login from "../components/Login";
import Typography from "@mui/material/Typography";
import Logbook from "../components/Logbook";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import Flights from "./Flights";
import {useParams, useSearchParams} from "react-router-dom";


export default function Signin () {

    const [searchParams, setSearchParams] = useSearchParams();

    const cause = searchParams.get('cause');
    const email = searchParams.get('email');


    return (
        <Box>
            <Box sx={{
                minHeight: 'calc(100vh - 0px)',
                display: 'flex',
                alignItems: 'stretch',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundImage: 'url("/etc/home-img/photo-0001.jpg")'
            }}>
                <Box flexGrow={1} sx={{
                    display:'flex',
                    flexDirection:'column',
                    alignItems:'center',
                    justifyContent:'space-between',
                    background:'#00000077',
                }}>
                    <Box sx={{
                        py:'2em',
                    }}>
                        <Box>
                            <img src={'/etc/img/cc-stadium-logo-white.png'} style={{width:'20em'}}/>
                        </Box>
                        <Typography variant={'h3'} component={'h2'} sx={{color:'#ffffff'}}>
                            Your soaring home on the cloud
                        </Typography>
                    </Box>
                    <Box sx={{
                        py:'2em',
                        color:'#ffffff',
                    }}>

                    </Box>
                </Box>
                <Box flexGrow={2} sx={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center',
                }}>
                    <Box sx={{
                        bgcolor:'#ffffff',
                        p:'1.5em 1.5em',
                    }}>
                        <Login cause={cause} prefillEmail={email}/>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}